import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MButton } from '@/components/ui/atoms/MButtons';
import { getMemberInfo } from '@/hooks/useMembers';

import { membersService } from '@/services/members.service';


const InviteMember: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const memberInfo = getMemberInfo();
  // The member to invite is passed in location.state
  const member = location.state?.targetMember || {};
  const backUrl = location.state?.backUrl;

  const [loading, setLoading] = React.useState(false);

  // Prefer mobile if both exist
  let contact = '';
  if (member.mobile) {
    contact = `+91-${member.mobile.slice(-8).padStart(8, 'x')}`;
  } else if (member.email) {
    contact = member.email;
  }

  const handleConfirmInvite = async () => {
    setLoading(true);
    try {
      let mode: 'mobile' | 'email' | undefined;
      if (member.mobile) {
        mode = 'mobile';
      } else if (member.email) {
        mode = 'email';
      }
      await membersService.inviteMember(member.id, mode);
      navigate('/profile/family/invite-success', { state: { memberName: member.first_name || member.firstName || '', backUrl } });
    } catch (error: any) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };


  const handleEditContact = () => {
    navigate('/profile/family/invite-contact-method', { state: { targetMember: member, backUrl } });
  }

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1 flex flex-col items-center justify-center px-6">
        <div className="text-2xl font-semibold text-neutral-900 text-left w-full mb-12 mt-8">
          Should we send an invite to {member.first_name || member.firstName || ''} on {contact}?
        </div>
        <div className="w-full flex flex-col gap-4 mt-8">
          {(member.mobile || member.email) && (
            <MButton
              variant="filled"
              size="lg"
              state={loading ? "disabled" : "default"}
              className="w-full"
              disabled={loading}
              onClick={handleConfirmInvite}
            >
              {loading ? "Inviting..." : "Confirm"}
            </MButton>
          )}
          <MButton
            variant="outline"
            size="lg"
            className="w-full"
            onClick={handleEditContact}
          >
            Edit contact
          </MButton>
          <MButton
            variant="outline"
            size="lg"
            state="default"
            className="w-full"
            onClick={() => navigate(-1)}
          >
            Cancel
          </MButton>
        </div>

      </div>
    </div>
  );
};

export default InviteMember;
